<template>
<v-container id="tour-intro-component" pa-0>
  <v-img  :src="step.url.url" height="100%"></v-img>
</v-container>
</template>

<script>
export default {
  name: "tour-intro-component",
  props: {
    step: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  mounted() {
    // console.log(this.step.url.url)
  },
  computed: {},
  methods: {
    goBack() {
      this.$store.dispatch("decrementStep");
    },
    goForward() {
      this.$store.dispatch("incrementStep");
    },
    swipe(direction) {
      //console.log('swiping', direction, this.numOfDialogViews)
      switch (direction) {
        case "right":
          if (this.currentDialogIndex === 0) {
            this.goBack();
          } else {
            this.currentDialogIndex -= 1;
          }
          break;
        case "left":
          if (this.currentDialogIndex + 1 === this.numOfDialogViews) {
            this.goForward();
          } else {
            this.currentDialogIndex += 1;
          }
          break;
      }
    }
  }
};
</script>

<style scoped>
#tour-intro-component {
  position: absolute;
  top: 0px;
  bottom: 0px;
}
</style>
